import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb,
  Input, Dropdown, MenuItem } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';
import axios from 'axios';
import moment from 'moment';

import CashFormatter from '../Common/cashFormatter';
import { ROOT_URL } from '../../actions/root_url';

const { Selectors } = Data;

export class BatchesModal2 extends Component {
  constructor() {
    super();
    this.state = {
      selectedBatch: {
        label: 'default',
        value: null,
        expire: null,
      },
      batchSelection: [],
      outputExpire: null,
    }
  }

  componentDidMount() {        
    let {selectedBatch} = this.state;
    this.setState({ selectedBatch });
  }

  componentWillReceiveProps(nextProps) {
    let {selectedBatch} = this.state;
    // if (this.props.batchesInfo !== nextProps.batchesInfo) {
    nextProps.batchesInfo && nextProps.batchesInfo.batches && nextProps.batchesInfo.batches.map(r=>{
      if (r.id === this.props.lineBatchId) {
        selectedBatch.label = `
          ${r.batch_num}: ${r.quantity}
          ${r.location 
            ? `- Location: ${r.location}` 
            : '- Location: N/A'}
          ${r.pallet_barcode 
            ? `- PLT barcode: ${r.pallet_barcode}` 
            : '- PLT barcode: N/A'}`;
        selectedBatch.value = r.id;
        selectedBatch.expiredDate = r.expire_datetime;
      }
    });

    this.setState({
      batchSelection: this.processBatchSelection(nextProps.batchesInfo.batches),
      selectedBatch
    })
    //   }
  }

  processBatchSelection = (batches = []) => {
    let avaliableBatches = batches.filter(batch => {
      return true;
    });
    avaliableBatches = avaliableBatches.sort((a, b) => {
      if (a.expire_datetime > b.expire_datetime) {
        return 1
      } 
      return -1
    });
    avaliableBatches = avaliableBatches.map(batch => ({
      label: `
        ${batch.batch_num}: ${batch.quantity}
        ${batch.location 
          ? `- Location: ${batch.location}` 
          : '- Location: N/A'}
        ${batch.pallet_barcode 
          ? `- PLT barcode: ${batch.pallet_barcode}` 
          : '- PLT barcode: N/A'}`,
      value: batch.id,
      expiredDate: batch.expire_datetime
    }));
    return avaliableBatches;
  }

  handleBatchSelected = (selectedBatch) => this.setState({ selectedBatch });

  handleOnSubmit = (e) => {
    const {
      selectedBatch,
      outputExpire
    } = this.state;
    const { lineBatchRows } = this.props;

    this.props.lineBatchRows.map((r,index)=>{
      if (r.SalesOrderLine_id === this.props.lineBatchIdx) {
        lineBatchRows[index].Batch_id_id = selectedBatch.value;
        lineBatchRows[index].Batch_id = selectedBatch.value;
        lineBatchRows[index].BatchExpiredDate = selectedBatch.expiredDate;
      }
    });

    this.props.onEditBatch(this.props.lineBatchRows);
    // const batch = selectedBatch.value ? selectedBatch : this.state.batchSelection[0];
    // this.props.onSelectedBatch(batch.value, batch.expiredDate);
  };

  render() {
    const {
    } = this.props;

    const {
      selectedBatch,
    } = this.state;

    return (
      <div>
        <Row style={{ marginBottom: "12px" }}>
          <Col sm={3}>
            <label style={{ float: 'right' }}>
              <Translate value="select_batch" />:
            </label>
          </Col>
          <Col sm={9}>
            <Dropdown>
              <Dropdown.Toggle
                style={{
                  width: "400px",
                  backgroundColor: "white",
                  border: "1px solid #555555",
                  color: "black",
                  fontWeight: "400",
                }}
              >
                {selectedBatch.label || selectedBatch}
              </Dropdown.Toggle>
              <Dropdown.Menu className="super-colors">
                {this.state.batchSelection.map((batch) => {
                  return (
                    <MenuItem onClick={() => this.handleBatchSelected(batch)} style={{
                      width: "400px",
                      backgroundColor: "white",
                      color: "black",
                      fontWeight: "400",
                    }}>
                      {batch.label}
                    </MenuItem>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>

        <Row className="centerStyle" style={{ marginTop: "50px" }}>
          <Button
            bsStyle="success"
            onClick={(e) => {
              this.handleOnSubmit(e);
            }}
          >
            <Translate value="edit_this_batch" />
          </Button>
        </Row>
      </div>
    );
  }
}

export default BatchesModal2;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/BatchesModal2.jsx